module.exports = __webpack_public_path__ + "img/Video Details and comment wireframes.d696b900.svg";